module.exports = __webpack_public_path__ + "img/edi-7.81ca6495.png";